import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSignIn } from 'react-auth-kit';
import { Formik } from 'formik';

function LoginForm() {


    const signIn = useSignIn();
    const navigate = useNavigate();
    let userId;

    return (
        <>
            <h1>Login</h1>
            <Formik
                initialValues={{ username: '', password: '' }}
                onSubmit={(values, { setSubmitting }) => {
                    axios.post('http://localhost:5000/login', { username: values.username, password: values.password })
                        .then((response) => {


                            if (response.status === 200) {
                                userId = response.data.id;
                                if (signIn(
                                    {
                                        token: response.data.token,
                                        expiresIn: 1000000,
                                        tokenType: "Bearer",
                                        authState: {
                                            id: response.data.id,
                                            name: response.data.username,
                                        },
                                        refreshToken: response.data.refreshToken,
                                        refreshTokenExpiresIn: 10000000
                                    }
                                )) {
                                    axios.post('http://localhost:5000/Roles/UserRoles', { id: userId })
                                        .then((response) => {
                                            if (response.data === null)  {
                                                navigate("/User/Profile");
                                            } else {
                                           if (response.data.name === "Admin") {
                                                navigate("/Admin");
                                           }
                                           if (response.data.name === "Patient") { 
                                                navigate("/Users/Profile");
                                           }
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        })
                                } else {
                                    // Throw error
                                }
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        })

                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="formContainer">
                            <label htmlFor="username">Username:</label>
                            <input type="text" id="username" name="username" onChange={handleChange} onBlur={handleBlur} values={values.username} placeholder="Username" />
                        </div>
                        <div className="formContainer">
                            <label htmlFor="password">Password:</label>
                            <input type="password" id="password" name="password" onChange={handleChange} onBlur={handleBlur} values={values.password} placeholder="Password" />
                        </div>
                        <button type="submit">Submit</button>
                    </form>
                )}
            </Formik>
        </>
    )
}

export default function Login() {

    return (
        <>

            <main className="Login">
                <section>

                    <article>
                        <LoginForm />
                    </article>
                    <article>
                        <img src={require("../assets/images/ipad.png")} className="logo" />
                    </article>


                </section>
            </main>
        </>
    )
}

